import {getCompetitionId} from './getCompetitionId';

export const createPath = (options, info) => {
    return options && info && info.type &&
        getCompetitionId(info.type.id, options)
}
